import { combineReducers } from "redux";
import * as types from "../constant";

export const userLoginReducer = (userInfo = {}, action) => {
  switch (action.type) {
    case types.USER_LOGIN_REQUEST:
      return { loading: true };
    case types.USER_LOGIN_SUCCESS:
      return { loading: false, userInfo: action.payload };
    case types.USER_LOGIN_FAIL:
      return { loading: false, error: action.payload };
    case types.USER_LOGOUT:
      return { loading: false, userInfo: null };
    default:
      return userInfo;
  }
};
export const userCompanyReducer = (companies = {}, action) => {
  switch (action.type) {
    case types.USER_COMPANIES_REQUEST:
      return { loading: true };
    case types.USER_COMPANIES_SUCCESS:
      return { loading: false, companies: action.payload };
    case types.USER_COMPANIES_FAIL:
      return { loading: false, error: action.payload };
    case types.USER_LOGOUT:
      return { loading: false, companies: null };
    default:
      return companies;
  }
};
export const ThemeTogglerReducer = (themeDisplay = {}, action) => {
  switch (action.type) {
    case types.THEME:
      return { themeDisplay: action.payload };
    default:
      return themeDisplay;
  }
};
export const PopUpPwaReducer = (popUp = {}, action) => {
  switch (action.type) {
    case types.POP_UP_PWA:
      return { popUp: action.payload };
    default:
      return popUp;
  }
};
export const UserDetailReducer = (userDetails = {}, action) => {
  switch (action.type) {
    case types.USER_DETAIL:
      return { userDetails: action.payload };
    default:
      return userDetails;
  }
};
export const ModalHandlerReducer = (modals = {}, action) => {
  switch (action.type) {
    case types.MODAL_HANDLER:
      return { modals: action.payload };
    default:
      return modals;
  }
};

export const CurrentCompanyReducer = (company = {}, action) => {
  switch (action.type) {
    case types.CURRENT_COMPANY:
      return { company: action.payload };

    default:
      return company;
  }
};
export const AppVersionReducer = (version = {}, action) => {
  switch (action.type) {
    case types.APP_VERSION:
      return { version: action.payload };
    default:
      return version;
  }
};

/* -------------- sell ----------------- */
export const AllUsersReducer = (users = {}, action) => {
  switch (action.type) {
    case types.ALL_USERS:
      return { users: action.payload };
    case types.RESET_ALL_STATE:
      return { users: {} };
    default:
      return users;
  }
};
export const allProductsReducer = (products = {}, action) => {
  switch (action.type) {
    case types.ALL_PRODUCTS:
      return { products: action.payload };
    case types.RESET_ALL_STATE:
      return { products: {} };
    default:
      return products;
  }
};
export const AllInvoiceReducer = (invoices = {}, action) => {
  switch (action.type) {
    case types.ALL_INVOICE:
      return { invoices: action.payload };
    case types.RESET_ALL_STATE:
      return { invoices: {} };
    default:
      return invoices;
  }
};
export const AllSummeryReducer = (summery = {}, action) => {
  switch (action.type) {
    case types.CATH_SUMMERY_DATA:
      return { summery: action.payload };
    case types.RESET_ALL_STATE:
      return { summery: {} };
    case types.RESET_SUMMERY_DATA:
      return { summery: {} };
    default:
      return summery;
  }
};

/* ----------------- buy ------------------ */
export const AllUsersBuyReducer = (users = {}, action) => {
  switch (action.type) {
    case types.BUY_ALL_USERS:
      return { users: action.payload };
    case types.RESET_ALL_STATE:
      return { users: {} };
    default:
      return users;
  }
};
export const allProductsBuyReducer = (products = {}, action) => {
  switch (action.type) {
    case types.BUY_ALL_PRODUCTS:
      return { products: action.payload };
    case types.RESET_ALL_STATE:
      return { products: {} };
    default:
      return products;
  }
};
export const AllInvoiceBuyReducer = (invoices = {}, action) => {
  switch (action.type) {
    case types.BUY_ALL_INVOICE:
      return { invoices: action.payload };
    case types.RESET_ALL_STATE:
      return { invoices: {} };
    default:
      return invoices;
  }
};
export const AllSummeryBuyReducer = (summery = {}, action) => {
  switch (action.type) {
    case types.BUY_CATH_SUMMERY_DATA:
      return { summery: action.payload };
    case types.RESET_ALL_STATE:
      return { summery: {} };
    case types.BUY_RESET_SUMMERY_DATA:
      return { summery: {} };
    default:
      return summery;
  }
};
const reducers = {
  userLogin: userLoginReducer,
  ThemeToggler: ThemeTogglerReducer,
  PopUpPwa: PopUpPwaReducer,
  UserDetail: UserDetailReducer,
  ModalHandler: ModalHandlerReducer,
  CurrentCompany: CurrentCompanyReducer,
  allProducts: allProductsReducer,
  userCompany: userCompanyReducer,
  AllUsers: AllUsersReducer,
  AllInvoice: AllInvoiceReducer,
  AppVersion: AppVersionReducer,
  AllSummery: AllSummeryReducer,
  /* ----------- for buy ----------- */
  AllUsersBuy: AllUsersBuyReducer,
  allProductsBuy: allProductsBuyReducer,
  AllInvoiceBuy: AllInvoiceBuyReducer,
  AllSummeryBuy: AllSummeryBuyReducer,
 
};

export default combineReducers(reducers);
